"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var system_1 = require("@mui/system");
var __1 = require("../../..");
function SideBarItem(_a) {
    var title = _a.title, icon = _a.icon, onClick = _a.onClick, isSelected = _a.isSelected, dataCy = _a["data-cy"], _b = _a.isDesktop, isDesktop = _b === void 0 ? false : _b, _c = _a.collapsed, collapsed = _c === void 0 ? false : _c;
    return ((0, jsx_runtime_1.jsxs)(system_1.Box, __assign({ position: "relative" }, { children: [isSelected && (0, jsx_runtime_1.jsx)(ActiveItemBar, { isDesktop: isDesktop }), (0, jsx_runtime_1.jsxs)(material_1.ListItem, __assign({ className: "side-bar-item", sx: {
                    color: isSelected
                        ? __1.theme.palette.primary.main
                        : __1.theme.palette.primary[400],
                    paddingLeft: collapsed ? '2.4rem' : isDesktop ? '2.7rem' : '4.0rem',
                    height: '5.6rem',
                    '&:hover': {
                        color: isSelected ? undefined : __1.theme.palette.primary[600],
                        cursor: 'pointer',
                    },
                }, onClick: onClick, "data-cy": dataCy }, { children: [(0, jsx_runtime_1.jsx)(material_1.ListItemIcon, __assign({ sx: {
                            minWidth: 0,
                            color: 'inherit',
                            width: '2.4rem',
                            height: '2.4rem',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                        } }, { children: icon({}) })), (0, jsx_runtime_1.jsx)(material_1.ListItemText, __assign({ className: "side-bar-item-text", sx: {
                            display: collapsed ? 'none' : 'block',
                            marginLeft: '1.2rem',
                            '& .MuiTypography-root': __assign({}, (isDesktop
                                ? __1.theme.typography.bodySmall
                                : __1.theme.typography.bodyMedium)),
                        } }, { children: title }))] }))] })));
}
exports.default = SideBarItem;
var ActiveItemBar = function (_a) {
    var _b = _a.isDesktop, isDesktop = _b === void 0 ? false : _b;
    return ((0, jsx_runtime_1.jsx)(system_1.Box, __assign({ sx: {
            display: 'flex',
            position: 'absolute',
            height: '100%',
        } }, { children: (0, jsx_runtime_1.jsx)(system_1.Box, { sx: {
                width: '4px',
                height: isDesktop ? '4rem' : '5.6rem',
                alignSelf: 'center',
                top: 0,
                left: 0,
                backgroundColor: 'primary.main',
                borderTopRightRadius: 999,
                borderBottomRightRadius: 999,
            } }) })));
};
